import React, { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { TourProvider } from "./context/TourContext";
import GuidedTour from "./components/GuidedTour";
import MaintenanceBanner from "./components/MaintenanceBanner";
import Home from "./pages/Home";
import Connexion from "./pages/Connexion";
import Inscription from "./pages/Inscription";
import ForgottenPassword from "./pages/ForgottenPassword";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import EnergyGauges from "./pages/EnergyGauges";
import Invitation from "./pages/Invitation";
import History from "./pages/History";

function RedirectToMaintenance() {
  useEffect(() => { window.location.href = '/maintenance.html'; }, []);
  return null;
}

function PrivateRoute({ element }) {
  const { state: user } = useContext(AuthContext);
  return user ? element : <Navigate to="/connexion" replace />;
}

function AppContent() {
  const { loading } = useContext(AuthContext);
  if (loading) return null;
  return (
    <>
      <GuidedTour />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/forgotten-password" element={<ForgottenPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/invitation/:token" element={<Invitation />} />
        <Route path="/settings" element={<PrivateRoute element={<Settings />} />} />
        <Route path="/gauges" element={<PrivateRoute element={<EnergyGauges />} />} />
        <Route path="/history" element={<PrivateRoute element={<History />} />} />
        <Route path="/maintenance" element={<RedirectToMaintenance />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <TourProvider>
      <BrowserRouter>
        <MaintenanceBanner />
        <AppContent />
      </BrowserRouter>
    </TourProvider>
  );
}

export default App;
